module.exports = __webpack_public_path__ + "static/media/ic_users.a1a1234d.svg";